import type { BearerToken } from '../../../integrations/allkort/graphql/interface/BankId';

export interface TokenHandlerActions {
    setAvailableTokens: (tokens: BearerToken[]) => void;
    setSelectedCustomer: (token: BearerToken) => void;
    setShowCustomerSelection: (show: boolean) => void;
    login: (token: BearerToken) => void;
    clearSameDeviceSession: () => void;
}

export const handleAuthenticationTokens = (
    tokens: BearerToken[],
    autoLoginStarted: { current: boolean },
    actions: TokenHandlerActions
): void => {
    if (tokens.length === 0 || autoLoginStarted.current) return;

    actions.setAvailableTokens(tokens);

    if (tokens.length === 1) {
        const token = tokens[0];
        actions.setSelectedCustomer(token);
        actions.setShowCustomerSelection(false);
        autoLoginStarted.current = true;
        actions.login(token);
        actions.clearSameDeviceSession();
        return;
    }

    actions.setShowCustomerSelection(true);
};
